import { render, staticRenderFns } from "./NewProjectModal.vue?vue&type=template&id=7f5c8f3f&scoped=true"
import script from "./NewProjectModal.vue?vue&type=script&lang=js"
export * from "./NewProjectModal.vue?vue&type=script&lang=js"
import style0 from "./NewProjectModal.vue?vue&type=style&index=0&id=7f5c8f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c8f3f",
  null
  
)

export default component.exports